export default __webpack_public_path__ + "static/media/cal.cbcaa8ed.svg";